import { alpha, type Theme } from '@mui/material/styles';

/**
 * Styles of the report branding page. Its hero, its picker, its banner and its pending marks
 * are the app settings page's (`AppSettings.styles.ts`), the other page that edits a layer
 * over the organization's, and its toolbar and preview are the report designer's; only what
 * neither has is here.
 */

/**
 * The fields on the left, the report as the server draws it on the right. Below `lg` the
 * preview goes under the fields, full width: a page of a report cannot be read in a narrow
 * column.
 */
export const layoutStyles = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', lg: '380px minmax(0, 1fr)' },
  gap: 2,
  alignItems: 'start',
  p: 2,
};

/** Under the picker: whose brand the reader's own reports carry. */
export const pickerNoteStyles = {
  display: 'block',
  mt: 0.75,
  maxWidth: 280,
  color: 'text.secondary',
};

/** The layout the preview is drawn in, among the selects of the preview's toolbar. */
export const layoutFieldStyles = {
  minWidth: 150,
  '& .MuiInputBase-input': { fontSize: 13 },
};

/** Under a field: whether this layer sets it, and what is printed where it does not. */
export const originStyles = {
  mt: 0.5,
  minHeight: 26,
  gap: 0.75,
  alignItems: 'center',
  flexWrap: 'wrap',
  rowGap: 0.25,
  fontSize: 12.5,
  color: 'text.secondary',
};

/** The words of the origin line give way before its marks do. */
export const originTextStyles = {
  minWidth: 0,
  overflowWrap: 'anywhere',
};

export const setHereDotStyles = {
  width: 6,
  height: 6,
  flexShrink: 0,
  borderRadius: '50%',
  backgroundColor: 'primary.main',
};

export const setHereStyles = {
  color: 'primary.light',
  fontWeight: 600,
};

export const revertButtonStyles = {
  ml: 'auto',
  p: 0.25,
  color: 'text.secondary',
  '& i': { fontSize: 16 },
  '&:hover': { color: 'text.primary' },
};

/** The logo of the layer beneath, in the box of a layer that sets none: there, but not this layer's own. */
export const inheritedLogoStyles = {
  '& img': { opacity: 0.55 },
};

/** What stands in the way of a save or a preview, over the fields. */
export const issueStyles = {
  px: 2,
  py: 1,
  gap: 1,
  alignItems: 'center',
  borderBottom: '1px solid',
  borderColor: 'divider',
  fontSize: 13,
  color: 'warning.light',
  backgroundColor: (theme: Theme) => alpha(theme.palette.warning.main, 0.08),
  '& i': { fontSize: 16 },
};
